import { initializeApp, getApps, getApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBaOfR02F4MMyBBg37VG0sImSzYyLN2IdA",
  authDomain: "honestai-9ccdb.firebaseapp.com",
  projectId: "honestai-9ccdb",
  storageBucket: "honestai-9ccdb.appspot.com",
  messagingSenderId: "1066639729397",
  appId: "1:1066639729397:web:1d8d55e50273617be85bbc",
  measurementId: "G-JTDT346ZT2"
};

  
// Initialize Firebase app only if it hasn't been initialized already
const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();

// Initialize Firebase services
const db = getFirestore(app);
const storage = getStorage(app);
const auth = getAuth(app);

export {db,storage,auth};
